import { render, staticRenderFns } from "./ErrorNotice.vue?vue&type=template&id=91340a32"
import script from "./ErrorNotice.vue?vue&type=script&lang=js"
export * from "./ErrorNotice.vue?vue&type=script&lang=js"
import style0 from "./ErrorNotice.vue?vue&type=style&index=0&id=91340a32&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports